<section class="col-xs-12 col-md-12 mt-5" id="errororder" *ngIf="enablePage.showSorryPage">
    <div class="thankorder_box">
        <div class="thankorder_text normalseason" [innerHtml]="data.content"></div>
        <div class="thankorder_text inseasonsorry" [innerHtml]="data.t1content"></div>
        <a class="showPopupclick" (click)="handleOnOrdersClick()">
            <div class="viewbutton">{{"startorderUk.viewOrders" | cxTranslate}}</div>
        </a>
    </div>
</section>